import { FooterLinkType } from './types'

export const footerLinks: FooterLinkType[] = []

export const socials = []